import Option from '@/modules/common/models/option/option.ts';

export default class UserOption extends Option {
  constructor(response: any) {
    super(response, 'LOGIN_ID', 'ФИО');
  }
}
